import { PosApiRequest } from "./pos-api-request";
import { TxnType } from "../types";

export abstract class TransactionRequest extends PosApiRequest {
  //Type of transaction to perform. This field is set by the specific request class and cannot
  TxnType: TxnType;

  // The currency code for this transaction (e.g. AUD). A 3 digit ISO currency code.
  CurrencyCode?: string | undefined;

  // Determines if the transaction is a training mode transaction. Set to TRUE if the transaction is to
  // be performed in training mode. The default is false.
  TrainingMode?: boolean | undefined;

  // The reference number to attach to the transaction. This will appear on the receipt.
  TxnRef: string;

  // The authorisation number for the transaction
  authCode?: number;
}
